import { JSONSchemaType } from 'ajv'

export interface IQbemApiConfigForm {
  email: string
  senha: string
  idEstipulante: string
  subestipulante: string
  idContratoQbem: string
  baseUrl: string
  autoConfirmar: boolean
  enableChangeMovements: boolean
  enviarAoQbem: boolean
}

const QbemApiConfigSchema: JSONSchemaType<IQbemApiConfigForm> = {
  type: 'object',
  properties: {
    email: { type: 'string' },
    senha: { type: 'string' },
    idEstipulante: { type: 'string' },
    subestipulante: { type: 'string' },
    // Vazio permitido (sem id); preenchido, so digitos.
    idContratoQbem: { type: 'string', pattern: '^[0-9]*$', errorMessage: 'Use apenas dígitos.' },
    // Optional. The form posts `baseUrl: baseUrl || undefined`, and the backend
    // falls back to "https://eb.qbem.net.br" when absent — keeping it required
    // would only block submissions while permitting an empty string (no minLength).
    baseUrl: {
      type: 'string',
    },
    autoConfirmar: {
      type: 'boolean',
    },
    enableChangeMovements: {
      type: 'boolean',
    },
    enviarAoQbem: {
      type: 'boolean',
    },
  },
  // Credenciais e estipulante so sao exigidos com o envio ligado. Desligado, o
  // contrato exporta so por e-mail e nao precisa de nada disso (Atlantica, 09/10).
  allOf: [
    {
      if: { properties: { enviarAoQbem: { const: true } } },
      then: {
        properties: {
          email: { type: 'string', minLength: 1, errorMessage: 'Email é obrigatório.' },
          senha: { type: 'string', minLength: 1, errorMessage: 'Senha é obrigatória.' },
          idEstipulante: { type: 'string', minLength: 1, errorMessage: 'ID do Estipulante é obrigatório.' },
          subestipulante: { type: 'string', minLength: 1, errorMessage: 'Subestipulante é obrigatório.' },
        },
      },
    },
  ],
  required: ['email', 'senha', 'idEstipulante', 'subestipulante', 'idContratoQbem', 'autoConfirmar', 'enableChangeMovements', 'enviarAoQbem'],
  additionalProperties: false,
}

export default QbemApiConfigSchema
